export default __webpack_public_path__ + "static/media/logoBraude.92452c91.png";